import { ReactElement } from "react";

import { useAuth0 } from "./AuthProvider";

export default function LogOutLink(): ReactElement | null {
  const auth0 = useAuth0();

  if (!auth0.user) {
    return null;
  }
  const handleLogout = () =>
    auth0.logout({
      logoutParams: {
        returnTo: `${window.location.origin}/login`
      }
    });

  return (
    <p>
      Not {auth0.user?.email}?{" "}
      <a href="#" onClick={handleLogout}>
        Log Out
      </a>
      .
    </p>
  );
}
